import { frontendURL } from 'dashboard/helper/URLHelper';
import KanbanIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_index',
    component: KanbanIndex,
    meta: {
      permissions: [
        'administrator',
        'supervisor',
        'agent',
        'conversation_manage',
        'conversation_unassigned_manage',
        'conversation_participating_manage',
      ],
    },
  },
];

export default { routes };
